import { isEmpty } from 'lodash';
import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';
import { constructURL } from '../common';

export const signedMyDocumentAPI = ({
    signedData = { file_name: '', account_id: '', account_name: '' },
}) => {
    const url = `${API.SIGNED_MD_URL}`;
    return fetchData({ body: signedData, method: METHODS.POST, url });
};

export const updateMyDocumentsAPI = ({ data = [] }) => {
    if (!Array.isArray(data)) {
        throw new Error('data should be an array of document detail');
    }
    const url = `${API.MY_DOCUMENTS}`;
    return fetchData({ body: data, method: METHODS.PUT, url });
};

export const createMyDocumentsAPI = ({ body }) => {
    const url = `${API.MY_DOCUMENTS}`;
    return fetchData({ body: body, method: METHODS.POST, url });
};

export const getAllMyDocumentsAPI = ({
    offset,
    limit,
    search = '',
    filter,
    account_id,
    folder_id,
    only_deleted = undefined,
    all = undefined,
}) => {
    const queryParams = {
        offset: offset ? offset : '',
        account_id: account_id || '',
        folder_id: folder_id || '',
        limit: limit ? limit : '',
        search: search ? encodeURIComponent(search) : '',
        filter: !isEmpty(filter) ? encodeURIComponent(JSON.stringify(filter)) : '',
        only_deleted,
        all,
    };
    const url = constructURL(API.MY_DOCUMENTS, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

export const deleteMyDocumentsAPI = ({ data = { ids: [], permanently: false } }) => {
    const url = `${API.MY_DOCUMENTS}`;
    return fetchData({ body: data, method: METHODS.DELETE, url });
};
